import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-popup-confirmation',
  templateUrl: './popup-confirmation.component.html',
  styleUrls: ['./popup-confirmation.component.scss']
})
export class PopupConfirmationComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<PopupConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

   

  ngOnInit(): void {

  }


  onOption2Click(): void {
    this.dialogRef.close("No");
    console.log("No button was clicked");
    }

  onOption1Click(): void{
    this.dialogRef.close("Yes");
    console.log("Yes button was clicked");
  }  
}
